import { Component, Input } from '@angular/core';
import { PRINT_STYLES } from './print-styles.config';
import { ModalController } from '@ionic/angular';

type TPdfDataElement = {
  displayName: string;
  value: number | string;
};

export type TBulkPdfDataElement = {
  pdfData: TPdfDataElement[];
  qrCodeValue: string;
};

export type TQRPaperSize = 'A4' | 'A2' | 'A4_SMALL' | 'SINGLE_COLUMN';
type TQRPaperSizeDisplayName = 'qr_code.A4' | 'qr_code.A2' | 'qr_code.A4_SMALL' | 'qr_code.SINGLE_COLUMN';

export type TQrPdfDimissEmitVal = {
  role: 'PRINT';
  data: true;
};

//Part of the PDF module, make sure to import the PDF module in the parent module
@Component({
  selector: 'monorepo-qr-pdf',
  templateUrl: './qr-pdf.component.html',
  styleUrls: ['./qr-pdf.component.scss'],
})
export class QrPdfComponent {
  //props
  @Input() bulkPdfData: TBulkPdfDataElement[] = [];
  @Input() factoryLogoSrc?: string;
  @Input() fileNameToDownload = '';

  //component related data
  templateOptions: TQRPaperSize[] = ['SINGLE_COLUMN', 'A4', 'A4_SMALL', 'A2'];
  templateDisplayVal: TQRPaperSizeDisplayName[] = [
    'qr_code.SINGLE_COLUMN',
    'qr_code.A4',
    'qr_code.A4_SMALL',
    'qr_code.A2',
  ];
  @Input() selectedTemplate: TQRPaperSize = this.templateOptions[0];
  pdfConfig: (typeof PRINT_STYLES)[TQRPaperSize] = PRINT_STYLES[this.selectedTemplate];

  constructor(private modalController: ModalController) {}

  onTemplateChange() {
    this.pdfConfig = PRINT_STYLES[this.selectedTemplate];
  }

  onClick() {
    this.modalController.dismiss(true, 'PRINT');
  }
}
